import { parseUTCDate } from '@/lib/utils'
import type { StatusTone } from '@/lib/status-tones'

const DAY_MS = 86_400_000
const ACTIVE_DAYS = 90
const QUIET_DAYS = 365

/** How recently the customer ordered: Active within 90 days, Quiet within a year, then Lapsed. */
export function orderRecency(
  lastOrderAt: string | null | undefined,
  now = Date.now(),
): { label: string; tone: StatusTone } {
  if (!lastOrderAt) return { label: 'No orders', tone: 'neutral' }
  const days = (now - parseUTCDate(lastOrderAt).getTime()) / DAY_MS
  if (days <= ACTIVE_DAYS) return { label: 'Active', tone: 'success' }
  if (days <= QUIET_DAYS) return { label: 'Quiet', tone: 'warning' }
  return { label: 'Lapsed', tone: 'neutral' }
}
